module.exports = __webpack_public_path__ + "img/logo-header.a7b8f4c7.png";